import { useEffect, useState } from "react";
import api from "../../../../services/api";
import FilterBar from "./FilterBar";

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  LabelList,
  Cell
} from "recharts";

function FichasBarChart() {
  const [dados, setDados] = useState([]);
  const [filtro, setFiltro] = useState({});

  // PALETA DE CORES PARA CADA BARRA
  const cores = [
    "#ff6b6b", // Não Vista
    "#ffa502", // Devolvida
    "#1e90ff", // Em Aberto
    "#2ed573", // Paga
  ];

  async function carregar(params = {}) {
    try {
      const res = await api.get("/v1/dashboard/ficha", {
        params: {
          dt1: params.inicio || "",
          dt2: params.fim || "",
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });

      const r = res.data || {};

      const arr = [
        { nome: "Não Vista", quantidade: r.fichanaovista || 0 },
        { nome: "Devolvida", quantidade: r.fichadevolvida || 0 },
        { nome: "Em Aberto", quantidade: r.fichaaberto || 0 },
        { nome: "Paga", quantidade: r.fichapaga || 0 },
      ];

      setDados(arr);

    } catch (err) {
      console.error("Erro ao carregar fichas:", err);
      setDados([]);
    }
  }

  function getPrimeiroEUltimoDiaMes() {
  const hoje = new Date();

  // Primeiro dia do mês
  const primeiroDia = new Date(hoje.getFullYear(), hoje.getMonth(), 1);

  // Último dia do mês
  const ultimoDia = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);

  return {
    inicio: primeiroDia.toISOString().split("T")[0],
    fim: ultimoDia.toISOString().split("T")[0]
  };
}

const datas = getPrimeiroEUltimoDiaMes();


  return (
    <div className="dashboard-card2">

      {/* HEADER */}
      <div className="header-row">
        <div className="dashboard-header">
          <i className="fa fa-clipboard-list"></i> Fichas
        </div>

        <button
          className="btn btn-outline-primary btn-sm btn-refresh"
          onClick={() => carregar(filtro)}
        >
          <i className="fa fa-sync"></i>
        </button>
      </div>

      <div className="dashboard-body">

        {/* FILTRO */}
        <FilterBar
          dataInicial={datas.inicio}
          dataFinal={datas.fim}
          onChange={(f) => {
            setFiltro(f);
            carregar(f);
          }}
        />

        {/* GRÁFICO */}
        <div className="chart-area" style={{ width: "100%", height: "260px" }}>
          {dados.length === 0 ? (
            <div>Sem dados</div>
          ) : (
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={dados} barSize={50}>
                <CartesianGrid strokeDasharray="3 3" stroke="#ddd" />

                <XAxis dataKey="nome" tick={{ fontSize: 12 }} />
                <YAxis tick={{ fontSize: 12 }} />
                <Tooltip contentStyle={{ fontSize: "14px" }} />

                <Bar
                  dataKey="quantidade"
                  radius={[8, 8, 0, 0]}
                  animationDuration={1200}
                  animationEasing="ease-out"
                >
                  {/* CORES DINÂMICAS POR BARRA */}
                  {dados.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={cores[index % cores.length]}
                    />
                  ))}

                  {/* VALOR EM CIMA DAS BARRAS */}
                  <LabelList
                    dataKey="quantidade"
                    position="top"
                    style={{ fill: "#333", fontWeight: "bold" }}
                  />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          )}
        </div>
      </div>
    </div>
  );
}

export default FichasBarChart;
